export default __webpack_public_path__ + "static/Catie_Hang_Le-e2a7389796135c1939a97f434133c19a.png";